import moment from 'moment-timezone';

export class DateUtil {

  static getCurrentUTC(): string {
    return moment().toISOString();
  }

  static getCurrentIST(): string {
    return moment().tz('Asia/Kolkata').format();
  }

}